const middleware = {}

middleware['analytics'] = require('../middleware/analytics.js')
middleware['analytics'] = middleware['analytics'].default || middleware['analytics']

middleware['cache'] = require('../middleware/cache.js')
middleware['cache'] = middleware['cache'].default || middleware['cache']

export default middleware
